const asArray = (collection) => collection?.$values ?? collection ?? [];

/**
 * Builds the text shown for a contact in an all-contacts list: the name, plus the companies the
 * contact is currently at so two people of the same name can be told apart (WK-565).
 *
 * Its own module (like phone-type-default.js) so contact-selector-with-create.jsx exports only a
 * component — react-refresh needs that to hot-reload the editor.
 */
export function formatContactDisplay(item) {
  if (!item) {
    return '';
  }
  const companies = asArray(item.companyNames);
  return companies.length > 0 ? `${item.fullName} — ${companies.join(', ')}` : item.fullName;
}
